module.exports = __webpack_public_path__ + "img/nicky.b4100dd7.png";